export const get_license_statistics = () => dispatch => 
	fetch(global.config.server_path + 'license/get_usage_statistics', {method: 'POST', credentials: 'include'})
	.then(resp => resp.json())
	.then(resp => global.validate_response(resp))
	.then(resp => resp.data)
	.catch(err => Promise.reject(err))
